/**
 * Script d'ajout automatique au panier pour les abonnements Views Magazine
 * Version: 7.0 FINAL - Sans propriétés personnalisées
 */

console.log('✅ Script subscription-click.js V7.0 chargé');

document.addEventListener('click', function(e) {
  // Ne s'activer QUE sur /collections/abonnement
  if (window.location.pathname !== '/collections/abonnement') {
    return;
  }
  
  // Trouver si le clic vient d'un lien <a>
  const link = e.target.closest('a[href*="/products/"]');
  
  if (!link) return;
  
  // Vérifier si le lien contient une des images ABO
  const imgInLink = link.querySelector('img');
  
  if (!imgInLink) return;
  
  const imgSrc = imgInLink.getAttribute('src') || '';
  
  // Déterminer quel abonnement selon l'image
  let config = null;
  
  if (imgSrc.includes('ABONNEMENT_1_AN')) {
    config = {
      name: 'Abonnement 1 an (4 numéros)',
      sellingPlanId: '689781473612',
      emoji: '📅'
    };
  } else if (imgSrc.includes('ABONNEMENT_2_ANS')) {
    config = {
      name: 'Abonnement 2 ans (8 numéros)',
      sellingPlanId: '689781506380',
      emoji: '📆'
    };
  }
  
  if (!config) return; // Pas une image ABO
  
  // 🔥 BLOCAGE TOTAL de la redirection
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();
  
  console.log(`${config.emoji} Clic sur ${config.name}`);
  
  // Feedback visuel
  link.style.opacity = '0.6';
  link.style.pointerEvents = 'none';
  
  // Récupérer l'URL du produit
  const productUrl = link.getAttribute('href');
  
  console.log('🛒 Ajout au panier...');
  
  // Étape 1 : Récupérer les données du produit
  fetch(productUrl + '.json')
    .then(response => response.json())
    .then(productData => {
      const product = productData.product;
      const defaultVariant = product.variants[0];
      
      console.log('📋 Produit:', product.title);
      console.log('🔢 Variant ID:', defaultVariant.id);
      
      // Étape 2 : Ajouter au panier avec abonnement (SANS propriétés)
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: defaultVariant.id.toString(),
            quantity: 1,
            selling_plan: config.sellingPlanId
          }]
        })
      });
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Erreur HTTP: ' + response.status);
      }
      return response.json();
    })
    .then(cartData => {
      console.log(`✅ ${config.name} ajouté au panier:`, cartData);
      
      // Redirection vers le panier
      setTimeout(function() {
        window.location.href = '/cart';
      }, 100);
    })
    .catch(error => {
      console.error('❌ Erreur:', error);
      link.style.opacity = '1';
      link.style.pointerEvents = 'auto';
      alert('Une erreur est survenue lors de l\'ajout au panier.');
    });
  
  return false;
}, true); // useCapture = true

console.log('✅ Script subscription-click.js V7.0 actif');
